import React from 'react';
import Icon from '../../../components/AppIcon';


const SystemHealthIndicator = ({ health, onRefresh }) => {
  const getHealthStatus = () => {
    if (!health?.supabaseConnected) return 'critical';
    if (health?.apiResponseTime > 1000) return 'warning';
    return 'healthy';
  };

  const status = getHealthStatus();

  const statusConfig = {
    healthy: {
      color: 'text-green-500',
      bgColor: 'bg-green-500/10',
      borderColor: 'border-green-500/20',
      icon: 'CheckCircle2',
      label: 'All Systems Operational'
    },
    warning: {
      color: 'text-yellow-500',
      bgColor: 'bg-yellow-500/10',
      borderColor: 'border-yellow-500/20',
      icon: 'AlertTriangle',
      label: 'Degraded Performance'
    },
    critical: {
      color: 'text-red-500',
      bgColor: 'bg-red-500/10',
      borderColor: 'border-red-500/20',
      icon: 'XCircle',
      label: 'System Issues Detected'
    }
  };

  const config = statusConfig?.[status];

  return (
    <div className={`mb-6 p-4 rounded-lg border ${config?.bgColor} ${config?.borderColor}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Icon name={config?.icon} size={24} className={config?.color} />
          <div>
            <h3 className={`font-semibold ${config?.color}`}>{config?.label}</h3>
            <p className="text-sm text-muted-foreground">
              {health?.lastChecked
                ? `Last checked: ${new Date(health.lastChecked)?.toLocaleTimeString()}`
                : 'Not checked yet'}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-4">
          {/* Health Metrics */}
          <div className="flex items-center gap-4 text-sm">
            <div className="flex items-center gap-2">
              <div className={`w-2 h-2 rounded-full ${
                health?.supabaseConnected ? 'bg-green-500' : 'bg-red-500'
              }`} />
              <span className="text-muted-foreground">Supabase</span>
            </div>
            {health?.apiResponseTime !== null && (
              <div className="flex items-center gap-2">
                <Icon name="Zap" size={14} className="text-muted-foreground" />
                <span className="text-muted-foreground">
                  {health?.apiResponseTime}ms
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemHealthIndicator;